import script from "./ApplicationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsPage.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationsPage.vue?vue&type=style&index=0&id=17cb5835&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17cb5835"]])

export default __exports__